// src/admin/pages/AdminMessageView.js
import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { FaPaperPlane, FaArrowLeft, FaCheckCircle } from "react-icons/fa";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import {
  getAdminMessageThread,
  adminReplyToMessage,
  adminUpdateMessageStatus,
} from "../../services/adminMessages.api";

function AdminMessageView() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { lang } = useContext(AdminLanguageContext);

    const TEXT = {
        EN: {
            back: "Back",
            ticket: "Ticket",
            from: "From",
            created: "Created",
            replyPlaceholder: "Type your reply...",
            send: "Send",
            close: "Close",
            closeSoon: "Close ticket feature coming soon!",
        },
        AR: {
            back: "رجوع",
            ticket: "تذكرة",
            from: "من",
            created: "تاريخ الإنشاء",
            replyPlaceholder: "اكتب ردك...",
            send: "إرسال",
            close: "إغلاق",
            closeSoon: "ميزة إغلاق التذكرة قادمة قريبًا!",
        },
    }[lang];

    const [isOpen, setIsOpen] = useState(false);
    const [ticket, setTicket] = useState(null);
    const [messages, setMessages] = useState([]);
    const [reply, setReply] = useState("");

    const bottomRef = useRef();

   useEffect(() => {
  async function load() {
    const thread = await getAdminMessageThread(id);
   setTicket({
  id: thread.id,
  name: thread.full_name,
  subject: thread.subject,
  status: thread.status,
  createdAt: new Date(thread.created_at).toLocaleDateString(),
  phone: thread.phone,
  email: thread.email,
});
    setMessages(thread.replies || []);
  }
  load();
}, [id]);


    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const sendReply = async () => {
  if (!reply.trim()) return;

  const body = reply;
  setReply("");

  // optimistic update
  setMessages((prev) => [
    ...prev,
    {
      sender_type: "staff",
      body,
      created_at: new Date().toISOString(),
    },
  ]);

  await adminReplyToMessage(id, body);
};


    if (!ticket) return null;

    return (
        <div className={`flex bg-gray-100 min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>

            <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            <div className="flex-1 lg:ml-64 transition-all">
                <AdminHeader setIsOpen={setIsOpen} />

                <main className="p-4 sm:p-6 animate-fadeSlide">

                    {/* BACK */}
                    <button
                        onClick={() => navigate("/admin/messages")}
                        className="flex items-center gap-2 text-cyan-700 font-semibold mb-4 hover:text-cyan-900"
                    >
                        <FaArrowLeft /> {TEXT.back}
                    </button>

                    {/* TITLE */}
                    <h1 className="text-xl sm:text-2xl font-bold text-cyan-700 mb-2">
                        {TEXT.ticket} #{ticket.id} — {ticket.subject}
                    </h1>

                    <div className="mb-6 space-y-1 text-sm sm:text-base text-gray-600">
  <p>
    {TEXT.from}: <b>{ticket.name}</b>
  </p>

  {(ticket.phone || ticket.email) && (
    <div className="flex flex-wrap gap-4 text-gray-700">
      {ticket.phone && (
        <span>📞 {ticket.phone}</span>
      )}
      {ticket.email && (
        <span className="truncate max-w-full">✉️ {ticket.email}</span>
      )}
    </div>
  )}

  <p className="text-gray-500 text-sm">
    {TEXT.created}: {ticket.createdAt}
  </p>
</div>


                    {/* CHAT */}
                    <div className="bg-white shadow-lg rounded-xl p-4 h-[60vh] overflow-y-auto border">
                        {messages.map((m, i) => (
  <div
    key={i}
    className={`flex mb-4 ${
      m.sender_type === "staff" ? "justify-end" : "justify-start"
    }`}
  >
    <div
      className={`max-w-[80%] p-3 rounded-xl break-words text-white ${
        m.sender_type === "staff"
          ? "bg-cyan-600"
          : "bg-gray-400"
      }`}
    >
      {/* ✅ MESSAGE BODY */}
      <p className="text-sm">{m.body}</p>

      {/* ✅ DATE BELOW MESSAGE */}
      <span className="text-xs opacity-80 block mt-1">
        {new Date(m.created_at).toLocaleString()}
      </span>
    </div>
  </div>
))}


                        <div ref={bottomRef} />
                    </div>

                    {/* REPLY */}
                    <div className="mt-4 flex flex-col sm:flex-row gap-3">
                        <input
                            type="text"
                            placeholder={TEXT.replyPlaceholder}
                            className="flex-1 p-3 border rounded-xl shadow-sm"
                            value={reply}
                            onChange={(e) => setReply(e.target.value)}
                        />

                        <button
                            onClick={sendReply}
                            className="bg-cyan-600 text-white px-5 py-3 rounded-xl hover:bg-cyan-700 flex items-center justify-center gap-2"
                        >
                            <FaPaperPlane /> {TEXT.send}
                        </button>

                        <button
                            onClick={async () => {
 await adminUpdateMessageStatus(id, "closed");
setTicket((t) => ({ ...t, status: "closed" }));
navigate("/admin/messages");
}}

                            className="bg-red-500 text-white px-5 py-3 rounded-xl hover:bg-red-600 flex items-center justify-center gap-2"
                        >
                            <FaCheckCircle /> {TEXT.close}
                        </button>
                    </div>

                </main>
            </div>
        </div>
    );
}

export default AdminMessageView;
